import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = { class: "inline-items" }
const _hoisted_6 = { class: "mr-md-5" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = { key: 5 }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = { key: 5 }
const _hoisted_32 = {
  key: 2,
  class: "spinner-border",
  role: "status"
}
const _hoisted_33 = { class: "sr-only" }
const _hoisted_34 = { class: "mt-4" }
const _hoisted_35 = { class: "table-responsive my-3 font-12" }
const _hoisted_36 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_37 = { class: "table-primary nowrap-text" }
const _hoisted_38 = { scope: "col" }
const _hoisted_39 = { scope: "col" }
const _hoisted_40 = { scope: "col" }
const _hoisted_41 = { scope: "col" }
const _hoisted_42 = {
  key: 0,
  scope: "col"
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "table-input-checked-wrap" }
const _hoisted_45 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "row align-items-center" }
const _hoisted_49 = { class: "col-md-8" }
const _hoisted_50 = { class: "inline-items" }
const _hoisted_51 = {
  key: 0,
  class: "mr-md-5"
}
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-md-8" }
const _hoisted_54 = {
  key: 0,
  class: "table-responsive font-12"
}
const _hoisted_55 = { class: "table table-bordered table-shadowed border" }
const _hoisted_56 = { class: "table-primary nowrap-text" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = {
  key: 1,
  class: "spinner-border",
  role: "status"
}
const _hoisted_60 = { class: "sr-only" }
const _hoisted_61 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_62 = { class: "shadowed-card" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-6" }
const _hoisted_65 = { class: "col-6 text-right" }
const _hoisted_66 = { class: "mb-1" }
const _hoisted_67 = { class: "col-6" }
const _hoisted_68 = { class: "col-6 text-right" }
const _hoisted_69 = { class: "mb-1" }
const _hoisted_70 = { class: "form-group" }
const _hoisted_71 = { class: "d-flex" }
const _hoisted_72 = { class: "control-wrap" }
const _hoisted_73 = /*#__PURE__*/_createVNode("div", { class: "dropdown-wrap position-relative" }, [
  /*#__PURE__*/_createVNode("a", {
    class: "btn-sm bg-light h-100 rounded-0",
    type: "button",
    "aria-expanded": "false"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "mr-3" }, "%")
  ])
], -1)
const _hoisted_74 = { class: "col-6" }
const _hoisted_75 = { class: "col-6 text-right" }
const _hoisted_76 = { class: "mb-1" }
const _hoisted_77 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-6" }
const _hoisted_80 = { class: "col-6 text-right" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = {
  key: 1,
  class: "shadowed-card"
}
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-6" }
const _hoisted_86 = { class: "col-6 text-right" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { class: "col-12" }
const _hoisted_90 = { class: "col-6" }
const _hoisted_91 = { class: "col-6 text-right" }
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 1 }
const _hoisted_94 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_95 = { class: "row" }
const _hoisted_96 = { class: "col-6" }
const _hoisted_97 = { class: "col-6 text-right" }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { class: "inline-items" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { key: 2 }
const _hoisted_104 = { class: "modal-wrap default-modal" }
const _hoisted_105 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "allInvoiceGenerate",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_106 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_107 = { class: "modal-content" }
const _hoisted_108 = { class: "modal-header" }
const _hoisted_109 = { class: "d-block" }
const _hoisted_110 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_111 = { class: "text-muted" }
const _hoisted_112 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_113 = { class: "modal-body" }
const _hoisted_114 = { class: "modal-wrap default-modal" }
const _hoisted_115 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "generateConfirmationModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_116 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_117 = { class: "modal-content" }
const _hoisted_118 = { class: "modal-header" }
const _hoisted_119 = { class: "d-block" }
const _hoisted_120 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_121 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_122 = { class: "modal-body" }
const _hoisted_123 = { class: "mb-3" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { key: 1 }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_big = _resolveComponent("big")
  const _component_PriceInputField = _resolveComponent("PriceInputField")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    (!_ctx.state.ui.isActive.createNewInvoice)
      ? (_openBlock(), _createBlock("a", {
          key: 0,
          id: "createNewProject",
          href: "javascript:void(0)",
          class: "btn default-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createNewInvoice && _ctx.createNewInvoice(...args)))
        }, [
          _hoisted_1,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('create_new')), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.ui.isActive.createNewInvoice)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("ul", null, [
                  _createVNode("li", _hoisted_6, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, _toDisplayString(_ctx.$t('create_invoice')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_7,
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.error.errorList.getInvoiceByPhaseOrTask,
            hasError: _ctx.state.ui.error.hasError
          }, null, 8, ["errors", "hasError"]),
          _createVNode("div", _hoisted_8, [
            (!_ctx.state.ui.isActive.createNewInvoice)
              ? (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode("p", null, [
                    _createVNode("strong", null, [
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('billed_from')) + " :", 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.email
            )
                    ? (_openBlock(), _createBlock("p", _hoisted_10, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.email), 1))
                    : _createCommentVNode("", true),
                  (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.full_name
            )
                    ? (_openBlock(), _createBlock("p", _hoisted_11, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.full_name), 1))
                    : _createCommentVNode("", true),
                  (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.address_line1
            )
                    ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.address_line1), 1))
                    : _createCommentVNode("", true),
                  (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.address_line2
            )
                    ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.address_line2), 1))
                    : _createCommentVNode("", true),
                  (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.city
            )
                    ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.city), 1))
                    : _createCommentVNode("", true),
                  (
              _ctx.state.data.invoiceDetails.billed_from_user &&
              _ctx.state.data.invoiceDetails.billed_from_user.country
            )
                    ? (_openBlock(), _createBlock("p", _hoisted_15, _toDisplayString(_ctx.state.data.invoiceDetails.billed_from_user.country), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode("p", null, [
                    _createVNode("strong", null, [
                      _createVNode(_component_big, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('billed_from')) + " :", 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (_ctx.state.data.activeUser && _ctx.state.data.activeUser.email)
                    ? (_openBlock(), _createBlock("p", _hoisted_17, _toDisplayString(_ctx.state.data.activeUser.email), 1))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.activeUser && _ctx.state.data.activeUser.full_name)
                    ? (_openBlock(), _createBlock("p", _hoisted_18, _toDisplayString(_ctx.state.data.activeUser.full_name), 1))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.activeUser && _ctx.state.data.activeUser.address_line1)
                    ? (_openBlock(), _createBlock("p", _hoisted_19, _toDisplayString(_ctx.state.data.activeUser.address_line1), 1))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.activeUser && _ctx.state.data.activeUser.address_line2)
                    ? (_openBlock(), _createBlock("p", _hoisted_20, _toDisplayString(_ctx.state.data.activeUser.address_line2), 1))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.activeUser && _ctx.state.data.activeUser.city)
                    ? (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString(_ctx.state.data.activeUser.city), 1))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.activeUser && _ctx.state.data.activeUser.country)
                    ? (_openBlock(), _createBlock("p", _hoisted_22, _toDisplayString(_ctx.state.data.activeUser.country), 1))
                    : _createCommentVNode("", true)
                ])),
            _createVNode("div", _hoisted_23, [
              _createVNode("p", null, [
                _createVNode("strong", null, [
                  _createVNode(_component_big, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('billed_to')) + " :", 1)
                    ]),
                    _: 1
                  })
                ])
              ]),
              (
              _ctx.state.data.invoiceReceiverList &&
              _ctx.state.data.invoiceReceiverList.length > 0 &&
              _ctx.state.data.invoiceDetails.to_role != 2
            )
                ? (_openBlock(), _createBlock("div", _hoisted_24, [
                    _withDirectives(_createVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.invoiceBillTo = $event))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                  .invoiceReceiverList, (invoice, invoiceIndex) => {
                        return (_openBlock(), _createBlock("option", {
                          value: invoice,
                          key: invoiceIndex
                        }, _toDisplayString(invoice.full_name) + "(" + _toDisplayString(invoice.email) + ") ", 9, ["value"]))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.state.data.invoiceBillTo]
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_25, [
                    (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.email
              )
                      ? (_openBlock(), _createBlock("p", _hoisted_26, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.email), 1))
                      : _createCommentVNode("", true),
                    (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.full_name
              )
                      ? (_openBlock(), _createBlock("p", _hoisted_27, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.full_name), 1))
                      : _createCommentVNode("", true),
                    (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.address_line1
              )
                      ? (_openBlock(), _createBlock("p", _hoisted_28, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.address_line1), 1))
                      : _createCommentVNode("", true),
                    (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.address_line2
              )
                      ? (_openBlock(), _createBlock("p", _hoisted_29, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.address_line2), 1))
                      : _createCommentVNode("", true),
                    (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.city
              )
                      ? (_openBlock(), _createBlock("p", _hoisted_30, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.city), 1))
                      : _createCommentVNode("", true),
                    (
                _ctx.state.data.invoiceDetails.billed_to_user &&
                _ctx.state.data.invoiceDetails.billed_to_user.country
              )
                      ? (_openBlock(), _createBlock("p", _hoisted_31, _toDisplayString(_ctx.state.data.invoiceDetails.billed_to_user.country), 1))
                      : _createCommentVNode("", true)
                  ])),
              (_ctx.state.ui.isPostLoading.showInvoiceReceiverModal)
                ? (_openBlock(), _createBlock("div", _hoisted_32, [
                    _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('loading1')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("p", _hoisted_34, [
            _createVNode("strong", null, [
              _createVNode(_component_big, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('title')) + " :", 1)
                ]),
                _: 1
              })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.state.data.invoiceDetails.title), 1)
          ]),
          _createVNode("div", _hoisted_35, [
            _createVNode("table", _hoisted_36, [
              _createVNode("thead", _hoisted_37, [
                _createVNode("tr", null, [
                  _createVNode("th", _hoisted_38, _toDisplayString(_ctx.$t('description')), 1),
                  _createVNode("th", _hoisted_39, _toDisplayString(_ctx.$t('cost_per_hour')), 1),
                  _createVNode("th", _hoisted_40, _toDisplayString(_ctx.$t('quantity_per_hour')), 1),
                  _createVNode("th", _hoisted_41, _toDisplayString(_ctx.$t('amount')), 1),
                  (_ctx.isAuthEdit)
                    ? (_openBlock(), _createBlock("th", _hoisted_42, _toDisplayString(_ctx.$t('action')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              (
              _ctx.isAuthEdit &&
              _ctx.state.data.invoiceDetails.invoice_items &&
              _ctx.state.data.invoiceDetails.invoice_items.length
            )
                ? (_openBlock(), _createBlock("tbody", _hoisted_43, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoiceCalculate, (invoiceDetail, invoiceDetailIndex) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: invoiceDetailIndex,
                        class: invoiceDetail.newAdded ? 'account-pending-invoice' : ''
                      }, [
                        _createVNode("td", null, [
                          _createVNode("div", _hoisted_44, [
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => (invoiceDetail.title = $event)
                            }, null, 8, ["onUpdate:modelValue"]), [
                              [_vModelText, invoiceDetail.title]
                            ]),
                            (invoiceDetail.invoice_uuid)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: 
                      invoiceDetail.invoice_uuid
                        ? 'input-checked-round-wrap'
                        : ''
                    
                                }, [
                                  _createVNode("i", {
                                    class: invoiceDetail.invoice_uuid ? 'fas fa-check' : ''
                                  }, null, 2)
                                ], 2))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("td", null, [
                          _createVNode(_component_PriceInputField, {
                            parentClass: 'form-control',
                            price: invoiceDetail.cost,
                            onUpdateItem: ($event: any) => (_ctx.updateItem(invoiceDetailIndex, $event)),
                            onKeyup: ($event: any) => (_ctx.calculateTotal(invoiceDetail))
                          }, null, 8, ["price", "onUpdateItem", "onKeyup"])
                        ]),
                        _createVNode("td", null, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => (invoiceDetail.quantity = $event)
                          }, null, 8, ["onUpdate:modelValue"]), [
                            [_vModelText, invoiceDetail.quantity]
                          ])
                        ]),
                        _createVNode("td", null, [
                          _withDirectives(_createVNode("input", {
                            disabled: "",
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": ($event: any) => (invoiceDetail.readAmount = $event)
                          }, null, 8, ["onUpdate:modelValue"]), [
                            [_vModelText, invoiceDetail.readAmount]
                          ])
                        ]),
                        _createVNode("td", null, [
                          (invoiceDetailIndex + 1 === _ctx.invoiceCalculate.length)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: "javascript:void(0)",
                                class: "btn enable-btn mr-1",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addItemInInvoice && _ctx.addItemInInvoice(...args)))
                              }, [
                                _hoisted_45,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            class: "btn delete-btn mr-1",
                            onClick: ($event: any) => (_ctx.removeSelectedItemInInvoice(invoiceDetail))
                          }, [
                            _hoisted_46,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                          ], 8, ["onClick"])
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("tbody", _hoisted_47, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                .invoiceDetails.invoice_items, (invoiceDetail, invoiceDetailIndex) => {
                      return (_openBlock(), _createBlock("tr", { key: invoiceDetailIndex }, [
                        _createVNode("td", null, _toDisplayString(invoiceDetail), 1),
                        _createVNode("td", null, _toDisplayString(invoiceDetail.title), 1),
                        _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.cost), 1),
                        _createVNode("td", null, _toDisplayString(invoiceDetail.quantity), 1),
                        _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.amount), 1)
                      ]))
                    }), 128))
                  ]))
            ])
          ]),
          _createVNode("div", _hoisted_48, [
            _createVNode("div", _hoisted_49, [
              _createVNode("div", _hoisted_50, [
                _createVNode("ul", null, [
                  (
                  _ctx.state.data.invoiceDetails &&
                  _ctx.state.data.invoiceDetails.invoice_no
                )
                    ? (_openBlock(), _createBlock("li", _hoisted_51, [
                        _createVNode("p", null, _toDisplayString(_ctx.$t('choose_unused_invoice')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_52, [
            _createVNode("div", _hoisted_53, [
              (
              _ctx.state.ui.isActive.createNewInvoice &&
              _ctx.state.data.invoices &&
              _ctx.state.data.invoices.length > 1
            )
                ? (_openBlock(), _createBlock("div", _hoisted_54, [
                    _createVNode("table", _hoisted_55, [
                      _createVNode("thead", _hoisted_56, [
                        _createVNode("tr", null, [
                          _createVNode("th", null, _toDisplayString(_ctx.$t('check')), 1),
                          _createVNode("th", null, _toDisplayString(_ctx.$t('invoice_number')), 1),
                          _createVNode("th", null, _toDisplayString(_ctx.$t('tasks')), 1),
                          _createVNode("th", null, _toDisplayString(_ctx.$t('status')), 1)
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invoices, (invoice, invoiceIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: invoiceIndex }, [
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                disabled: invoice.generated === 1,
                                "onUpdate:modelValue": ($event: any) => (invoice.isChecked = $event)
                              }, null, 8, ["disabled", "onUpdate:modelValue"]), [
                                [_vModelCheckbox, invoice.isChecked]
                              ])
                            ]),
                            _createVNode("td", null, _toDisplayString(invoice.invoice_no), 1),
                            _createVNode("td", null, _toDisplayString(invoice.title), 1),
                            (invoice.generated === 1)
                              ? (_openBlock(), _createBlock("td", _hoisted_57, _toDisplayString(_ctx.$t('generated')), 1))
                              : _createCommentVNode("", true),
                            (invoice.generated != 1 && invoiceIndex != 0)
                              ? (_openBlock(), _createBlock("td", _hoisted_58, _toDisplayString(_ctx.$t('not_generated')), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createVNode("a", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.insertSelectedInvoice && _ctx.insertSelectedInvoice(...args))),
                      href: "javascript:void(0)",
                      class: "btn default-btn mr-2"
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.insertSelectedInvoice
                  ? _ctx.$t('loading1')
                  : _ctx.$t('insert')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.ui.isLoading.phaseInvoiceListById)
                ? (_openBlock(), _createBlock("div", _hoisted_59, [
                    _createVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('loading1')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isAuthEdit)
              ? (_openBlock(), _createBlock("div", _hoisted_61, [
                  _createVNode("div", _hoisted_62, [
                    _createVNode("div", _hoisted_63, [
                      _createVNode("div", _hoisted_64, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('sub_total')), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_65, [
                        _createVNode("div", _hoisted_66, [
                          _withDirectives(_createVNode("input", {
                            disabled: "",
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.invoice.readSubTotal = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.invoice.readSubTotal]
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_67, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('tax')), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_68, [
                        _createVNode("div", _hoisted_69, [
                          _createVNode("div", _hoisted_70, [
                            _createVNode("div", _hoisted_71, [
                              _createVNode("div", _hoisted_72, [
                                _withDirectives(_createVNode("input", {
                                  type: "text",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.invoice.tax = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.state.data.invoice.tax]
                                ])
                              ]),
                              _hoisted_73
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_74, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('discount')), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_75, [
                        _createVNode("div", _hoisted_76, [
                          _createVNode(_component_PriceInputField, {
                            parentClass: 'form-control',
                            price: _ctx.state.data.invoice.discount,
                            onUpdateItem: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateDiscount($event))),
                            disabled: "disableDiscountInput",
                            onKeydown: _ctx.handleKeyPress
                          }, null, 8, ["price", "onKeydown"])
                        ])
                      ])
                    ]),
                    _hoisted_77,
                    _createVNode("div", _hoisted_78, [
                      _createVNode("div", _hoisted_79, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, [
                            _createVNode(_component_big, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('total')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_80, [
                        (_ctx.invoiceTotal)
                          ? (_openBlock(), _createBlock("p", _hoisted_81, "$" + _toDisplayString(_ctx.invoiceTotal), 1))
                          : (_openBlock(), _createBlock("p", _hoisted_82, "$0"))
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_83, [
                  _createVNode("div", _hoisted_84, [
                    _createVNode("div", _hoisted_85, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('sub_total')), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_86, [
                      (_ctx.state.data.invoiceDetails.sub_total)
                        ? (_openBlock(), _createBlock("p", _hoisted_87, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.sub_total), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_88, "$0"))
                    ]),
                    _createVNode("div", _hoisted_89, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('tax')) + " (" + _toDisplayString(_ctx.state.data.invoiceDetails.tax) + "%)", 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_90, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('discount')), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_91, [
                      (_ctx.state.data.invoiceDetails.discount)
                        ? (_openBlock(), _createBlock("p", _hoisted_92, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.discount), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_93, "$0"))
                    ])
                  ]),
                  _hoisted_94,
                  _createVNode("div", _hoisted_95, [
                    _createVNode("div", _hoisted_96, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, [
                          _createVNode(_component_big, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('total')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_97, [
                      (
                  _ctx.state.data.invoiceDetails && _ctx.state.data.invoiceDetails.total
                )
                        ? (_openBlock(), _createBlock("p", _hoisted_98, " $" + _toDisplayString(_ctx.state.data.invoiceDetails.total), 1))
                        : (_openBlock(), _createBlock("p", _hoisted_99, "$0"))
                    ])
                  ])
                ]))
          ]),
          _createVNode("div", _hoisted_100, [
            _createVNode("ul", null, [
              (_ctx.isAuthEdit && _ctx.state.ui.isActive.createNewInvoice)
                ? (_openBlock(), _createBlock("li", _hoisted_101, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn default-btn outline mr-2",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showGenerateConfirmation && _ctx.showGenerateConfirmation(...args)))
                    }, _toDisplayString(_ctx.$t('generate_invoice')), 1),
                    _createVNode("a", {
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancelSelectedInvoice && _ctx.cancelSelectedInvoice(...args))),
                      href: "javascript:void(0)",
                      class: "btn btn-danger"
                    }, _toDisplayString(_ctx.$t('cancel')), 1)
                  ]))
                : _createCommentVNode("", true),
              (
              _ctx.state.data.invoiceDetails &&
              _ctx.state.data.invoiceDetails.generated === 0 &&
              _ctx.state.data.invoiceDetails.user_role != 2 &&
              _ctx.state.data.isIndividual
            )
                ? (_openBlock(), _createBlock("li", _hoisted_102, [
                    (
                _ctx.state.data.invoiceDetails &&
                !_ctx.state.data.invoiceDetails.draft_uuid
              )
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          class: "btn default-btn outline draft-btn",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.saveAsDraft && _ctx.saveAsDraft(...args)))
                        }, _toDisplayString(_ctx.state.ui.isPostLoading.saveAsDraft
                  ? _ctx.$t('loading1')
                  : _ctx.$t('save_as_draft')), 1))
                      : (_openBlock(), _createBlock("a", {
                          key: 1,
                          href: "javascript:void(0)",
                          class: "btn default-btn outline draft-btn",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (
                _ctx.redirectToRequestedDraftInvoice(
                  _ctx.state.data.invoiceDetails.draft_uuid,
                  '1'
                )
              ))
                        }, _toDisplayString(_ctx.$t('go_to_draft')), 1))
                  ]))
                : _createCommentVNode("", true),
              (
              _ctx.state.data.invoiceDetails &&
              _ctx.state.data.invoiceDetails.pdf_url &&
              _ctx.state.data.invoiceDetails.status != 4 &&
              !_ctx.state.ui.isActive.createNewInvoice
            )
                ? (_openBlock(), _createBlock("li", _hoisted_103, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: "btn default-btn outline",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
                    }, _toDisplayString(_ctx.$t('download_pdf')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_104, [
      _createVNode("div", _hoisted_105, [
        _createVNode("div", _hoisted_106, [
          _createVNode("div", _hoisted_107, [
            _createVNode("div", _hoisted_108, [
              _createVNode("div", _hoisted_109, [
                _createVNode("h5", _hoisted_110, _toDisplayString(_ctx.$t('all_invoice')), 1),
                _createVNode("p", _hoisted_111, _toDisplayString(_ctx.$t('all_received_invoices_listed')) + ". ", 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideAllInvoiceGenerate && _ctx.hideAllInvoiceGenerate(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_112
              ])
            ]),
            _createVNode("div", _hoisted_113, [
              _createVNode("p", null, _toDisplayString(_ctx.$t('do_you_want_to_include_invoice')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.invoiceWithGenerated(1)))
              }, _toDisplayString(_ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.invoiceWithGenerated(0)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_114, [
      _createVNode("div", _hoisted_115, [
        _createVNode("div", _hoisted_116, [
          _createVNode("div", _hoisted_117, [
            _createVNode("div", _hoisted_118, [
              _createVNode("div", _hoisted_119, [
                _createVNode("h5", _hoisted_120, _toDisplayString(_ctx.$t('generate_invoice')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideGenerateConfirmation && _ctx.hideGenerateConfirmation(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_121
              ])
            ]),
            _createVNode("div", _hoisted_122, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.getInvoiceByPhaseOrTask,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("p", _hoisted_123, _toDisplayString(_ctx.$t('do_you_want_to_create_invoice')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.stripeAccountCheck && _ctx.stripeAccountCheck(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.generateInvoice
                    ? _ctx.$t('loadong1')
                    : _ctx.$t('generate_invoice')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-danger",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.hideGenerateConfirmation && _ctx.hideGenerateConfirmation(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 2,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          isButton: "true"
        }, {
          default: _withCtx(() => [
            (_ctx.state.data.stripeUrl)
              ? (_openBlock(), _createBlock("div", _hoisted_124, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t('you_dont_have_stripe_account')), 1),
                  (!_ctx.state.ui.isPostLoading.stripeAccount)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "btn-link mt-2",
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.redirectToStripeAccount && _ctx.redirectToStripeAccount(...args)))
                      }, _toDisplayString(_ctx.$t('click_to_setup_account')), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_125, _toDisplayString(_ctx.$t('loading1')), 1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.stripeSuccess)
              ? (_openBlock(), _createBlock("div", _hoisted_126, [
                  (!_ctx.state.ui.isPostLoading.generateInvoice)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.generateInvoice(1)))
                      }, _toDisplayString(_ctx.$t('click_to_generate_invoice')), 1))
                    : (_openBlock(), _createBlock("p", _hoisted_127, _toDisplayString(_ctx.$t('loading1')), 1))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}